"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuButton = exports.Menu = void 0;
exports.MenuGroup = MenuGroup;
exports.MenuList = exports.MenuItem = void 0;
exports.MenuSeperator = exports.MenuSeparator = MenuSeparator;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _button = _interopRequireDefault(require("@ux/button"));
var _canUseDom = _interopRequireDefault(require("@ux/component-utilities/can-use-dom"));
var _flyout = require("@ux/flyout");
var _dropdown = require("./dropdown");
const _excluded = ["as", "id", "children", "isTouch", "onSelect", "closeOnSelect", "rtl", "size"],
  _excluded2 = ["className", "portal", "placement", "children", "stretch", "flip", "strategy"],
  _excluded3 = ["as"],
  _excluded4 = ["as", "buttonAs", "className"],
  _excluded5 = ["as", "isLink", "href"],
  _excluded6 = ["className"];
/* eslint-disable no-undefined */
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const menuSizes = ['default', 'md', 'sm', 'small'];

/**
 * Menu expects only two children: MenuList and MenuButton
 */
const Menu = exports.Menu = /*#__PURE__*/_react.default.forwardRef((_ref, forwardedRef) => {
  let {
      as: Comp = 'div',
      id,
      children,
      isTouch,
      onSelect,
      closeOnSelect,
      rtl = false,
      size
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const props = _objectSpread({
    ref: forwardedRef,
    id,
    className: (0, _classnames.default)('ux-menu', {
      [`ux-menu--${size}`]: menuSizes.includes(size)
    })
  }, rest);
  return /*#__PURE__*/_react.default.createElement(Comp, props, /*#__PURE__*/_react.default.createElement(_dropdown.DropdownProvider, {
    closeOnSelect: closeOnSelect,
    id: id,
    isTouch: isTouch,
    onSelect: onSelect,
    rtl: rtl,
    size: size
  }, children));
});
Menu.propTypes = {
  /** Rendered Component/Element */
  as: _propTypes.default.any,
  /** MenuButton and MenuList */
  children: _propTypes.default.node.isRequired,
  /** Close menu when selection occurs */
  closeOnSelect: _propTypes.default.bool,
  /** HTML ID attribute */
  id: _propTypes.default.string.isRequired,
  /** Is touch inferace */
  isTouch: _propTypes.default.bool,
  /** Selected item */
  onSelect: _propTypes.default.func,
  /** Is right to left text */
  rtl: _propTypes.default.bool,
  /** Menu size */
  size: _propTypes.default.oneOf(menuSizes)
};
Menu.displayName = 'Menu';

/**
 * MenuList is the container of all MenuItem, MenuGroup, or MenuSeparator it encapsulates these items in a popover
 */
const MenuList = exports.MenuList = /*#__PURE__*/_react.default.forwardRef((_ref2, forwardedRef) => {
  let {
      className,
      portal = (0, _canUseDom.default)() ? document.body : null,
      placement,
      children,
      stretch,
      flip,
      strategy
    } = _ref2,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  const cx = (0, _classnames.default)('ux-menu-list', {
    [className]: !!className
  });
  return /*#__PURE__*/_react.default.createElement(_dropdown.DropdownPopover, {
    flip: flip,
    portal: portal,
    position: placement,
    stretch: stretch,
    strategy: strategy
  }, /*#__PURE__*/_react.default.createElement(MenuListbox, (0, _extends2.default)({
    className: cx,
    ref: forwardedRef
  }, props), children));
});
MenuList.propTypes = {
  /** Classes applied to a list */
  className: _propTypes.default.string,
  /** MenuItems */
  children: _propTypes.default.node.isRequired,
  /** Determines if the flyout should flip when space is limited */
  flip: _propTypes.default.bool,
  /** Loop through items when using keyboard navigation */
  loop: _propTypes.default.bool,
  /** Orientation of list */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
  /** Flyout placement of the listbox */
  placement: _propTypes.default.oneOf(_flyout.UX_FLYOUT_PLACEMENTS),
  /** Element to portal list into */
  portal: _propTypes.default.object,
  /** Sets the strategy for @floating-ui (absolute/fixed) */
  strategy: _propTypes.default.oneOf(['absolute', 'fixed']),
  /** Should the list width match the trigger/button width */
  stretch: _propTypes.default.bool
};
MenuList.displayName = 'MenuList';
const MenuListbox = /*#__PURE__*/_react.default.forwardRef((_ref3, forwardedRef) => {
  let {
      as: Comp = 'div'
    } = _ref3,
    rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  const {
    props
  } = (0, _dropdown.useDropdownListbox)(_objectSpread(_objectSpread({
    role: 'menu'
  }, rest), {}, {
    ref: forwardedRef
  }));
  return /*#__PURE__*/_react.default.createElement(Comp, props);
});
MenuListbox.propTypes = {
  /** Rendered Component/Element */
  as: _propTypes.default.any,
  /** Loop through items when using keyboard navigation */
  loop: _propTypes.default.bool,
  /** Orientation of listbox */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
};
MenuListbox.displayName = 'MenuListbox';
const MenuButton = exports.MenuButton = /*#__PURE__*/_react.default.forwardRef((_ref4, forwardedRef) => {
  let {
      as: Comp = _button.default,
      buttonAs,
      className
    } = _ref4,
    rest = (0, _objectWithoutProperties2.default)(_ref4, _excluded4);
  const {
    data: {
      isExpanded,
      controls
    },
    props
  } = (0, _dropdown.useDropdownTrigger)(_objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef
  }));
  const cx = (0, _classnames.default)('ux-menu-button', {
    [className]: !!className
  });
  return /*#__PURE__*/_react.default.createElement(Comp, (0, _extends2.default)({
    "aria-expanded": isExpanded,
    "aria-haspopup": true,
    "aria-controls": controls,
    className: cx,
    as: buttonAs
  }, props));
});
MenuButton.propTypes = {
  /** Rendered Component/Element */
  as: _propTypes.default.any,
  /** Proxy the Button component `as` prop */
  buttonAs: _propTypes.default.oneOf(['cta', 'select', 'toggle', 'external']),
  /** Classes applied to a MenuButton */
  className: _propTypes.default.string,
  /** Icon to be used in Button */
  icon: _propTypes.default.node,
  /** Button size */
  size: _propTypes.default.oneOf(menuSizes)
};
MenuButton.displayName = 'MenuButton';

/**
 * MenuItem and MenuLink share most of the same functionality captured here.
 */
const MenuItem = exports.MenuItem = /*#__PURE__*/_react.default.forwardRef((_ref5, forwardedRef) => {
  let {
      as: Comp = 'div',
      isLink,
      href
    } = _ref5,
    rest = (0, _objectWithoutProperties2.default)(_ref5, _excluded5);
  const {
    data: {
      size
    },
    props
  } = (0, _dropdown.useDropdownItem)(_objectSpread(_objectSpread({
    isLink: isLink !== null && isLink !== void 0 ? isLink : !!href
  }, rest), {}, {
    ref: forwardedRef
  }));
  const {
      className
    } = props,
    sharedProps = (0, _objectWithoutProperties2.default)(props, _excluded6);
  const cx = (0, _classnames.default)('ux-menu-item', {
    [className]: !!className,
    'ux-menu-item--small': size === 'small'
  });
  if (href && Comp === 'div') {
    Comp = 'a';
  }
  return /*#__PURE__*/_react.default.createElement(Comp, (0, _extends2.default)({
    href: href || undefined,
    className: cx,
    role: "menuitem"
  }, sharedProps));
});
MenuItem.propTypes = {
  /** Rendered Component/Element */
  as: _propTypes.default.any,
  /** Classes applied to a MenuItem */
  className: _propTypes.default.string,
  /** When href is present, it will convert MenuItem to <a> */
  href: _propTypes.default.string,
  /** Identifies if the item should be treated like a link */
  isLink: _propTypes.default.bool,
  /** Prop override for text value of item */
  valueText: _propTypes.default.string
};
MenuItem.displayName = 'MenuItem';

/**
 * Group of menu items with a label
 * @param {Object} props - Configuration object
 * @returns {Component} - <MenuGroup/> component
 */
function MenuGroup(_ref6) {
  let {
    children,
    className,
    label
  } = _ref6;
  const cx = (0, _classnames.default)('ux-menu-group', {
    [className]: !!className
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cx,
    role: "group"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ux-menu-group-label"
  }, label), children);
}
MenuGroup.propTypes = {
  /** label/text of the menu group header  */
  label: _propTypes.default.string.isRequired,
  /** menu items */
  children: _propTypes.default.node.isRequired,
  /** Classes applied to a MenuGroup */
  className: _propTypes.default.string
};
MenuGroup.displayName = 'MenuGroup';
function MenuSeparator(_ref7) {
  let {
    className
  } = _ref7;
  const cx = (0, _classnames.default)('ux-menu-separator', {
    [className]: !!className
  });
  return /*#__PURE__*/_react.default.createElement("hr", {
    className: cx
  });
}
MenuSeparator.propTypes = {
  className: _propTypes.default.string
};
MenuSeparator.displayName = 'MenuSeparator';